import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters';
// modules
import user from './modules/user'
import comp from './modules/comp'
import enumStore from './modules/enumStore';
import ecosystem from './modules/ecosystem';
import workspace from './modules/workspace';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  getters,

  modules: {
    user,
    comp,
    enumStore,
    ecosystem,
    workspace
  }
})
